<template>
  <TwPopup
    :title="(activeCarItem && activeCarItem.productCode ? '编辑' : '添加') + '地点备注名'"
    :open="open"
    :showFooter="false"
    @change="handleChange"
  >
    <view class="a-p-30-10-0-10 a-flex a-col a-ai-c">
      <view class="a-w-100% a-fs-28 a-fw-500 a-lh-28 a-c-#14 a-ta-l">填写或选择备注名称</view>
      <view class="a-w-100% a-h-300 a-br-12 a-mt-20 a-p-30-24 a-bg-#F8F8F8">
        <view class="a-flex">
          <view
            v-for="(item, index) in tags"
            :key="item.type"
            class="tag-item"
            :class="{ active: item.type === activeType }"
            @click="switchType(item)"
          >
            {{ item.name }}
            <text class="tripwise_outline icon-correct_outline"></text>
          </view>
        </view>
        <textarea
          :value="remark"
          class="a-fs-24 a-h-160 a-mt-30"
          placeholder="填写备注名称，最多支持10个字"
          palceholder-style="color: #bfbfbf"
          :maxlength="10"
          @input="textareaChange"
        ></textarea>
      </view>
    </view>
    <view class="a-p-20-0 a-flex a-ai-c a-jc-sb">
      <view class="btn-item a-border-#bfbfbf a-c-#595959 a-mr-20" @click="handleChange(false)">取消</view>
      <view class="btn-item a-border-#F85A5B a-c-#ffffff a-bg-#F85A5B a-c-#fff" @click="handleConfirm">确认</view>
    </view>
  </TwPopup>
</template>

<script>
import TwPopup from '@/componentsV3/common/tw-popup/index.vue';
export default {
  components: { TwPopup },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    activeCarItem: Object,
  },
  data() {
    return {
      tags: [
        { type: 1, name: '家' },
        { type: 2, name: '公司' },
        { type: 3, name: '车站' },
        { type: 4, name: '机场' },
      ],
      activeType: null,
      remark: '',
    };
  },
  watch: {
    activeCarItem: {
      handler(val) {
        if (val) {
          this.activeType = Number(val.productCode);
          this.remark = val.remark;
        } else {
          this.activeType = null;
          this.remark = '';
        }
      },
      immediate: true,
    },
  },
  methods: {
    textareaChange(e) {
      this.remark = e.detail.value;
      this.activeType = null;
    },
    switchType(item) {
      this.remark = '';
      this.activeType = item.type;
    },
    handleChange(show) {
      this.$emit('change', show);
    },
    handleConfirm() {
      if (!this.activeType && !this.remark) {
        this.$app.Toast('请填写地点备注名');
        return;
      }
      const params = {
        mainId: this.activeCarItem && this.activeCarItem.id,
        productCode: this.remark ? 99 : this.activeType,
        remark: this.remark,
        productType: this.activeCarItem && this.activeCarItem.productType,
      };
      uni.$emit('editRemark', params);
      this.handleChange(false);
    },
  },
};
</script>

<style lang="less" scoped scoped>
.tag-item {
  width: 25%;
  height: 48rpx;
  line-height: 48rpx;
  text-align: center;
  background: #fff;
  border-radius: 6rpx;
  margin-right: 10rpx;
  font-size: 24rpx;
  color: #141414;
  box-shadow: 0px 8rpx 20rpx 0px rgba(0, 0, 0, 0.02);
  position: relative;
  border: 1rpx solid #fff;
  &:last-child {
    margin-right: 0;
  }
  .icon-correct_outline {
    display: none;
    position: absolute;
    right: -1px;
    bottom: -1px;
    width: 20rpx;
    height: 16rpx;
    color: #fff;
    background-color: #057bff;
    border-radius: 6rpx 0 6rpx 0;
    align-items: center;
    justify-content: center;
    font-size: 12rpx;
  }
  &.active {
    border-color: #057bff;
    .icon-correct_outline {
      display: flex;
    }
  }
}
.btn-item {
  width: 335rpx;
  height: 80rpx;
  border-radius: 8rpx;
  line-height: 80rpx;
  text-align: center;
  font-size: 32rpx;
}
</style>
